import { useGetAuthMe } from "@birdwatch/client";
import { RedirectToSignIn, useUser } from "@clerk/clerk-react";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { LoadingOverlay } from "@/components/ui/loading-overlay";
import { APP_ROUTERS } from "@/constants/app-routers";
import { getUserRole } from "@/libs/user-role";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { isSignedIn, isLoaded } = useUser();

  const { data: me, isPending } = useGetAuthMe().get();

  const {
    isManager,
    isCoordinator,
    isOwner,
    isTechnician,
    isEvaluator,
    isAdmin,
  } = getUserRole(me?.roles || []);

  if (!isLoaded || isPending) {
    return <LoadingOverlay />;
  }

  if (!isSignedIn) {
    return <RedirectToSignIn />;
  }

  // Already signed in then check role

  // if (isAdmin) {
  //   return <Navigate to="/admin/service-areas" />;
  // }

  if (isAdmin || isManager || isCoordinator || isTechnician || isEvaluator) {
    return <Navigate to="/office/tasks" />;
  }

  if (isOwner) {
    // `replace`: without it, Back returns to `/`, which re-decides and pushes forward
    // again — the user can never navigate away.
    return <Navigate to={APP_ROUTERS.MY_HOME} replace />;
  }

  return null;
}
